module.exports = __webpack_public_path__ + "img/folder-empty.9b99860d.svg";